exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tasks {\n  margin-bottom: 1.5rem;\n}\n.task {\n  font-size: 16px;\n  overflow: hidden;\n}\n\n.task label {\n  display: block;\n  float: left;\n  padding-right: 10px;\n  white-space: nowrap;\n  width: 100%;\n  text-align: left;\n}\n\n.task {\n  font-size: 16px;\n}\n\n.task input {\n  vertical-align: middle;\n  margin-right: 9px;\n}\n\n.task {\n  font-size: 16px;\n}\n\n.task label span {\n  vertical-align: middle;\n  cursor: context-menu;\n}\n\n.task .trash {\n  color: red;\n  cursor: pointer;\n}\n\n.add-task .input {\n  margin: 5px;\n}\n\n.add-task input[type=\"text\"] {\n  margin-right: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/client/client-tasks/client-tasks.component.css
// module id = ../../../../../src/app/_components/client/client-tasks/client-tasks.component.css
// module chunks = main